module.exports = __webpack_public_path__ + "img/icon-thumbs-up-grey.a046095c.svg";